export default {
  event(name, payload) {
    console.warn(`Triggered GA event: ${name}. Params:`, payload);
    return window.gtag('event', name, payload);
  },
};
